import React, { FC, Suspense, useEffect } from 'react'
import { Loading, TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { DataLoader } from './ConfirmDataLoader'
import { ContractModificationErrorHandler } from '../ContractModificationErrorHandler'
import { ContractModificationRequestPreview } from './ContractModificationRequestPreview'
import { ConfirmContractModificationForm } from './ModificationConfirmForm'
import { ConfirmSuccess } from './Success'

import { View } from 'components'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

export const ConfirmContractModification: FC = () => {
  const { t } = useTranslation(['common', 'contractModification', 'titles'])
  const [view, setView] = React.useState<'default' | 'success'>('default')
  const [params] = useSearchParams()
  const { frontPagePath } = useContractPaths()

  useEffect(() => {
    if (params.get('success')) {
      setView('success')
    }
  }, [params, setView])

  return (
    <TitleController title={t('titles:contractModification')}>
      <View>
        <View.Header>
          <View.HeaderLink to={frontPagePath}>
            {t('common:views.home')}
          </View.HeaderLink>

          <View.HeaderTitle>
            {t('contractModification:view.title')}
          </View.HeaderTitle>
        </View.Header>
        <View.Sidebar />
        <View.Content>
          <Suspense fallback={<Loading variant="details" />}>
            <ContractModificationErrorHandler view="confirm">
              <DataLoader>
                {(data) => (
                  <>
                    {view === 'success' && <ConfirmSuccess />}

                    {view === 'default' && (
                      <ConfirmContractModificationForm
                        contractModificationRequestId={
                          data.contractModificationRequest.id
                        }
                        userMetadata={data.userMetadata}
                      >
                        <ContractModificationRequestPreview
                          contractModificationRequest={
                            data.contractModificationRequest
                          }
                          tenants={data.tenants}
                        />
                      </ConfirmContractModificationForm>
                    )}
                  </>
                )}
              </DataLoader>
            </ContractModificationErrorHandler>
          </Suspense>
        </View.Content>
      </View>
    </TitleController>
  )
}
